(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('a[href$="#open-iubenda"]').addEventListener('click',(e) => { e.preventDefault(); document.querySelector('.iubenda-cs-preferences-link').click(); })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halue-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'halue-wishlist-products';

    function getHandles() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    }

    function syncGrid() {
      var handles = getHandles();
      var grid = document.getElementById('halue-wishlist-grid');
      if (!grid) return;

      grid.querySelectorAll('.product-card-ajax[data-handle]').forEach(function (card) {
        if (handles.indexOf(card.dataset.handle) === -1) {
          card.remove();
        }
      });

      if (!grid.querySelector('.product-card-ajax')) {
        grid.hidden = true;
        var empty = document.getElementById('halue-wishlist-empty');
        if (empty) empty.hidden = false;
      }
    }

    function hideSpinner() {
      var spinner = document.getElementById('halue-wishlist-spinner');
      if (spinner) spinner.hidden = true;
    }

    function init() {
      var handles = getHandles();
      var grid = document.getElementById('halue-wishlist-grid');
      var empty = document.getElementById('halue-wishlist-empty');

      if (!grid) return;

      if (handles.length === 0) {
        hideSpinner();
        if (empty) empty.hidden = false;
        return;
      }

      var parser = new DOMParser();

      Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + encodeURIComponent(handle) + '?view=product-card-ajax')
            .then(function (r) {
              return r.ok ? r.text() : null;
            })
            .catch(function () {
              return null;
            });
        })
      ).then(function (htmls) {
        var inserted = 0;

        htmls.forEach(function (html) {
          if (!html) return;
          var doc = parser.parseFromString(html, 'text/html');
          var card = doc.querySelector('.product-card-ajax');
          if (card) {
            grid.appendChild(card);
            inserted++;
          }
        });

        hideSpinner();

        if (inserted > 0) {
          grid.hidden = false;
        } else {
          if (empty) empty.hidden = false;
        }
      });
    }

    window.addEventListener('halue-wishlist:updated', syncGrid);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
